import { cn } from "@/lib/cn";

interface LogoProps {
  size?: number;
  withWordmark?: boolean;
  subtitle?: string;
  className?: string;
}

/** SpectrAI mark - violet diamond + optional wordmark. */
export function Logo({ size = 32, withWordmark = true, subtitle, className }: LogoProps) {
  const mark = (
    <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true">
      <defs>
        <linearGradient id="crystal-grad" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#A855F7" />
          <stop offset="100%" stopColor="#7C3AED" />
        </linearGradient>
        <linearGradient id="crystal-shine" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#FFFFFF" stopOpacity=".4" />
          <stop offset="100%" stopColor="#FFFFFF" stopOpacity="0" />
        </linearGradient>
      </defs>
      <path d="M16 3 L27 12 L22 28 L10 28 L5 12 Z" fill="url(#crystal-grad)" />
      <path d="M16 3 L22 28 L16 16 Z" fill="#7C3AED" opacity=".55" />
      <path d="M16 3 L10 28 L16 16 Z" fill="url(#crystal-shine)" />
    </svg>
  );

  if (!withWordmark) {
    return <div className={cn("inline-flex items-center", className)}>{mark}</div>;
  }

  return (
    <div className={cn("inline-flex items-center", className)}>
      <div className="inline-flex items-center gap-2.5 dark:hidden">
        {mark}
        <div className="flex flex-col leading-tight">
          <span className="text-[15px] font-semibold tracking-tight text-ink">SpectrAI</span>
          {subtitle && <span className="text-[11px] text-ink-soft">{subtitle}</span>}
        </div>
      </div>
      <div className="hidden flex-col dark:flex">
        <img
          src="/spectr-logo-dark.png"
          alt="SpectrAI"
          className="w-auto object-contain"
          style={{ height: size }}
        />
        {subtitle && <span className="mt-0.5 text-[11px] text-ink-soft">{subtitle}</span>}
      </div>
    </div>
  );
}
